<template>
    <EBN_Expiring-component>
        <b-row>
            <b-col md="12" class="mt-3">
                <div>
                    <b-row>
                        <b-col md="4">
                            <b-form-group >
                                    <b-form-textarea v-model="searching" style="height:100px" placeholder="Type to Search : 1023,Test"></b-form-textarea>
                                    
                                        
                            </b-form-group>
                            <!-- <div>
                            <span style="color:red">Note:For Multiple Search Use comma(,) Separator </span>
                            </div> -->
                                
                        </b-col>

                        <b-col md="2">
                            <b-button :disabled="searching.length == 0" @click="searchENB_expiring()"  size="md" variant="primary">Search</b-button>
                            &nbsp;
                            <b-button :disabled="searching.length == 0" @click="clearENB_expiring()"    size="md" variant="danger">Clear</b-button>
                        </b-col>   
                        
                        <b-col md="6">
                            <div class="text-right">
                                <b-button   @click="downloadENB_expiring()" size="md" variant="primary">Download</b-button>
                            </div>
                        </b-col>
                   
                    </b-row> 
                </div>

                
                <div id="DatePickerdiaplay" style="display:none; margin: 15px 15px;">
                    <b-row>
                        <b-col xl="5" lg="5" md="5">
                            <b-form-group label="From Date:"  :label-cols="3" >
                                <v-date-picker mode='single' input-class="dateInput" :disabled-dates='[
                                    {
                                      start:null,
                                      end: new Date()
                                    },
                                    {
                                      start: null,
                                      end: new Date()
                                    }
                                  ]'
                                  v-model='selectDateFrom'>
                                </v-date-picker>
                            </b-form-group>
                        </b-col>
                        <b-col xl="6" lg="6" md="6">
                            <b-button variant="info" @click="manuallyUpdateRecord()" :disabled="isReadOnly">Manually Update</b-button>
                        </b-col>
                    </b-row>
                </div>

                <div class="text-right">
                    <b>Total Records : <strong style="color: red;">{{totalRows}}</strong></b>
                </div>
                

                <b-table responsive show-empty :busy="isBusy" :items="EBN_expriryCount" :fields="fields"  :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"  @filtered="onFiltered" :tbody-tr-class="rowClass"> 

                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle">
                      </b-spinner>
                      <strong>Loading...</strong>
                    </div> 
                    <template slot="select" slot-scope="row">
                        <input type="checkbox" @change="multiselectdesign($event)" v-bind:value="row.item.parentawb"  class="designcheckbox"  v-model="CheckLoadID" >
                    </template>
                    <!-- {{ row.item }}ghjn{{ row.item.invoiceno }} -->
                </b-table>
                
                <paginate
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                </paginate>

                
            </b-col>
        </b-row>
    </EBN_Expiring-component>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    data() {
        return {
            isBusy: false, 
            // fields: [
            //     { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
            //     { key: 'parentawb', label : 'Parent AWB', sortable: true},
            //     { key: 'invoiceno', label : 'Load ID', sortable: true},
            //     { key: 'gstinno', label : 'GST No', sortable: true},
            //     { key: 'ebn', label : 'EBN', sortable: true},
            //     { key: 'ebnexpirydate', label : 'EBN Expiry Date', sortable: true},
            //     { key: 'sellergstregnumber', label : 'Seller GST No.', sortable: true},
            //     { key: 'sourcecity', label : 'Source City', sortable: true},
            //     { key: 'sourcepincode', label : 'Source Pincode', sortable: true},
            //     { key: 'shipmentstatus', label : 'Shipment Status', sortable: true},
            //     { key: 'deliverystatus', label : 'Delivery Status', sortable: true},
                
            // ],
            fields :[],
            EBN_expriryCount :[],
            isBusy : false,
            noofpages:'',
            pageNum:1,
            searching :[],
            searchvaluesarr:[],
            totalRows :0,
            CheckLoadID :[],
            SelectLoadID :[],
            selectDateFrom: '',
            route_id : null,
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.User_type = userInfo.user_type;

        this.route_id = this.$route.params.id;


        this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();

        this.EBNExpiryRecords(this.pageNum);
        // this.manuallyUpdateRecord();
    },
    methods: {
        ischeckbodyvalidation(){
        for (let i = 0; i < this.accessBody.length; i++) {
            const element = this.accessBody[i];
        
            if (element.title=='ENB Extension' && element.isReadonly==true && this.route_id=='normal') {
            this.isReadOnly=true
            }
        if (element.child) {
            for (let j = 0; j < element.child.length; j++) {
            const k = element.child[j];
            if (k.title=='ENB Extension' && k.isReadonly==true && this.route_id=='normal') {
                this.isReadOnly=true
            }
            if (k.title=='ENB Extension' && k.isReadonly==true && this.route_id=='asn') {
                this.isReadOnly=true
            }
            
            }
        }
        }
        console.log(" this.isReadOnly", this.isReadOnly)
        },
        clickCallback(pageNum){

            this.EBNExpiryRecords(pageNum);
        },

        EBNExpiryRecords : function(pageNo){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.isBusy=true;
            if (this.route_id=='normal') {
                this.fields=[
                    { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
                    { key: 'parentawb', label : 'Parent AWB', sortable: true},
                    { key: 'invoiceno', label : 'Load ID', sortable: true},
                    { key: 'gstinno', label : 'GST No', sortable: true},
                    { key: 'ebn', label : 'EBN', sortable: true},
                    { key: 'ebnexpirydate', label : 'EBN Expiry Date', sortable: true},
                    { key: 'error', label : 'EBN Error', sortable: true},
                    { key: 'sellergstregnumber', label : 'Seller GST No.', sortable: true},
                    { key: 'sourcecity', label : 'Source City', sortable: true},
                    { key: 'sourcepincode', label : 'Source Pincode', sortable: true},
                    { key: 'shipmentstatus', label : 'Shipment Status', sortable: true},
                    { key: 'deliverystatus', label : 'Delivery Status', sortable: true},
                    
                ]
            }
            
            if (this.route_id=='asn') {
                this.fields=[
                    { key: 'select', label: 'Select', sortable: true, sortDirection: 'desc' },
                    { key: 'parentawb', label : 'Parent AWB', sortable: true},
                    { key: 'invoiceno', label : 'Load ID', sortable: true},
                    { key: 'gstinno', label : 'GST No', sortable: true},
                    { key: 'ebn', label : 'EBN', sortable: true},
                    { key: 'ebnexpirydate', label : 'EBN Expiry Date', sortable: true},
                    { key: 'sellergstregnumber', label : 'Buyer GST No.', sortable: true},
                    { key: 'sourcecity', label : 'Source City', sortable: true},
                    { key: 'sourcepincode', label : 'Source Pincode', sortable: true},
                    { key: 'shipmentstatus', label : 'Shipment Status', sortable: true},
                    { key: 'deliverystatus', label : 'Delivery Status', sortable: true},
                    { key: 'error', label : 'Error', sortable: true},
                ]
            }
            
            const obj={
                page_no:`${pageNo}`,
                recordtype:this.searchvaluesarr.length>0?"search":"expired",
                searchpayld:this.searchvaluesarr.length>0?this.searchvaluesarr:[],
                is_asn: this.route_id=='normal' ? 'NO': 'YES',
            }
            console.log("obj",obj)
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getEBNExpiryRecordsofCurrentDate`,obj)
            .then(result => {
                console.log("result",result)
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                this.EBN_expriryCount=result.body.returnvalue;
                console.log("EBN_expriryCount",this.EBN_expriryCount);
                this.totalRows = result.body.totalcount;  
                    console.log("HHHHH",this.totalRows); 
                this.noofpages=parseInt(this.totalRows)/20;
                console.log("this.noofpages",this.noofpages)
                this.noofpages=Math.ceil( this.noofpages);
                console.log("YYYYYY",this.noofpages)
                
                }else{
                    this.EBN_expriryCount=[];
                    this.totalRows=0;
                }
            }).catch(ex => {
                console.log("error", ex);
            });
        },

        searchENB_expiring(){
      
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);
            var searchvalues=[];
            this.searchvaluesarr=[];
            searchvalues = this.searching.split(',')
            for (var i = 0; i < searchvalues.length; i++) {
                this.searchvaluesarr.push(`${searchvalues[i]}`)
            }
            console.log("YYY",this.searchvaluesarr)
            this.pageNum=1;
            this.EBN_expriryCount=[];
            this.totalRows=0;
            this.EBNExpiryRecords(this.pageNum)
        },

        clearENB_expiring(){
            this.searching=[];
            this.searchvaluesarr=[];
            this.pageNum=1;
            this.EBN_expriryCount=[];
            this.totalRows=0;
            this.EBNExpiryRecords(this.pageNum)
        },

        downloadENB_expiring(){
            // alert("i")
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                recordtype:this.searchvaluesarr.length>0?"search":"expired",
                searchpayld:this.searchvaluesarr.length>0?this.searchvaluesarr:[],
                is_asn: this.route_id=='normal' ? 'NO': 'YES',
            }
            console.log("obj",obj)
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getEBNExpiryRecordsofCurrentDateCSVDownload`,obj)
            .then(result => {
                console.log("result",result)
                document.getElementById("overlay").style.display = "none";
                    if(result.body=="success")
                    {
                    // alert("Please Check Ur Mail For Downlod Link")
                    this.$fire({
                             text:"Please Check Your Mail For Downlod Link",
                             type: "success",
                             timer: 30000
                           });
                }
                else
                {
                    // alert("Can not Download");
                    this.$fire({
                             text:"Can not Download",
                             type: "error",
                             timer: 30000
                           });
                }
            }).catch(ex => {
                console.log("error", ex);
            });
        },

        multiselectdesign(e){
        this.SelectLoadID=[];
        console.log("this.SelectLoadID",this.SelectLoadID)
        // this.CheckLoadID=[];
        var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            console.log("this.CheckLoadID",this.CheckLoadID)
                if (this.CheckLoadID.length >0)

                {
                // alert("in");
                console.log("CheckLoadID",this.CheckLoadID);
                this.SelectLoadID=this.CheckLoadID;
                    document.getElementById("DatePickerdiaplay").style.display ="block";
                    // }
                }
                
                else{
                document.getElementById("DatePickerdiaplay").style.display ="none";
                }

        },

        manuallyUpdateRecord :function () {
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var today = this.selectDateFrom;
            // Current Date
            var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

            console.log("date",date)
            const obj={
                allparrentawbArr:this.CheckLoadID,
                ebnexpdate:`${date}`,
            }
            console.log("obj",obj)
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/manuallyUpdateEBNExpiryRecords`,obj)
            .then(result => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    }); 
                    this.pageNum=1;
                    this.EBNExpiryRecords(this.pageNum);
                    document.getElementById("DatePickerdiaplay").style.display = "none"; 
                    this.CheckLoadID=[];
                    this.selectDateFrom =[];
                } else {
                        this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    }); 
                }
            }).catch(ex => {
                console.log("error", ex);
            });
        },
        rowClass(item, type) {
            if(item){
            if (item.error!=null) { 
                return 'table-danger'
            }
            }
        },

    },
    computed: {
      rows() {
        return this.EBN_expriryCount.length
      }
    },
}
</script>